//==========================================================
// Dictionnaire vee-validate contenant les messages et attributs en anglais
//
// Permet de : * personnaliser/traduire les noms des champs de formulaire : * personnaliser/traduire les messages d'erreurs custom

//==========================================================


export default {

    // Définition des noms des champs
    // (https://baianat.github.io/vee-validate/guide/messages.html#field-names)
    attributes: {
        // form signup
        signup_organization: "organization",
        signup_email: "email address",
        signup_firstname: "firstname",
        signup_name: "name",
        signup_password: "password",
        signup_cgv: "__terms",
        signup_invitation_code: "__invitation code",
        signupData_org_size: '__"taille de l\'organisation"',
        signupData_org_type: '__"type de l\'organisation"',
        signupData_position_other: '"__rôle"',
        signupData_org_goal: '"__goal"',

        // form login
        login_email: "email address",
        login_password: "password",

        // form pwdRequest
        pwdRequest_email: "e-mail",

        // form pwdReset
        pwdReset_password: "__mot de passe",
        pwdReset_password_confirm: "__confirmation",

        // form userSetting
        userSetting_firstname: "__firstname",
        userSetting_name: "__name",
        userSetting_titre: "__title",

        userSetting_email: "__e-mail",
        userSetting_orgName: '__"organization name"',

        userSetting_currentPassword: "__current password",
        userSetting_newPassword: "__new password",

        // form trEditModal
        trEditModal_timeIn: "__clock in",
        trEditModal_timeOut: "__clock out",

        // form tasktrEditModal
        taskTrEditModal_timeIn: '"__clock in"',
        taskTrEditModal_timeOut: '"__clock out"',

        // form newTask
        newTask_taskName : '"__task name"'


        // form project management
        ,modalProjectManagement_name : '"__Project name"'

        // form tag management
        ,modalTagManagement_name : '"__Tag name"'

        // form client management
        ,modalClientManagement_name : '"__Client name"'

        // form user management
        ,modalUserManagement_name : '"__user name"'
        ,modalUserManagement_firstname : '"__user firstname"'
        ,modalUserManagement_email : '"__user email"'
        ,modalUserManagement_emailList : '"__email adresses list"'

    }
    // Définition des messages d'erreur personnalisés
    // (https://baianat.github.io/vee-validate/guide/messages.html#field-specific-custom-messages)
    , custom: {
        // form signup
        signup_cgv: {
            required: '__ You must accept terms'
        },

        userSetting_email: {
            excluded: "__L'adresse e-mail est identique"
        },

        // modalProjectManagementComp
        modalProjectManagement_color: {
            required: "__Please pick a color"
        },

        // modalTagManagementComp
        modalTagManagement_color: {
            required: "__Please pick a color"
        },
    },

    // Définition des messages d'erreurs des validateurs custom
    custom_validator: {
        signup_invitation_code: "__Invitation code is not valid"
        ,signup_email_availability: "__Email address is already registered"

        , pwd_request_email_not_found: "__ Email address was not found"
        , userSetting_orgName: "__ Organization name is not correct"

    }
}
